import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import { IMaskInput } from "react-imask";
import withReactContent from 'sweetalert2-react-content'
import { getCurrentUser, MidiasAceita } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import { FaCheck } from "react-icons/fa";
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SeletorIdiomaCampo } from '../../common/_components/SeletorIdioma';

import { getConfig } from "../../common/config";

class MinhaContaEdit extends Component {
    constructor(props) {
        super(props);
        
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.handleLaboratorioVinculadoChange = this.handleLaboratorioVinculadoChange.bind(this);
        this.handleMidiasContatoChange = this.handleMidiasContatoChange.bind(this);

        this.list_tipos_pessoa = {
            "fisica": "Física", 
            "juridica": "Jurídica"
        };
        this.list_categorias = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais",
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clínicas",
            "plataformas": "Plataformas",
            "laboratorio_diagnostico": "Laboratórios de Análise Clínica",
            "cooperativas_saude": "Cooperativas de Saúde",
        };
        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino",
            "O": "Outro",
        },
        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

        this.state = {
            nome: '',
            razao_social: "",
            nome_fantasia: "",
            tipo_pessoa: "fisica",
            telefone: "",
            celular: "",
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            uf: '',
            cidade: '',
            genero: '',
            registro: '',
            registro_uf: '',
            categoria: 'medicos',
            contato_nome: '',
            contato_email: '',
            contato_celular: '',
            senha: '',
            senha_confirma: '',
            midias_contato: ["sms","email","whatsapp","telefone"],
            nomeHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            telefoneHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            contatoNomeHelper: '',
            contatoEmailHelper: '',
            contatoCelularHelper: '',
            titulo_pagina: "",
            loading: false,
            erroLoadRegistro: '',
            prestador_id: '',
            clientes: [],
            programas: [],
            programa_dados: [],
            termo_conteudo: "",
            showTermsModal: false,
            aceitaTermos: false,
            mostrarSenha: { senha: false, senhaConfirma: false },
            programa_uuid: '',
            cliente_uuid: '',
            loading_render: true,
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
            laboratoriosDisponiveis: [], // Lista de laboratórios disponíveis
            laboratoriosSelecionados: [], // IDs dos laboratórios selecionados

        };
    }

    componentDidMount(){
        const { t } = this.props;

        const dados_user = getCurrentUser();
        let id = 0;

        if(dados_user['tipo_usuario'] == 'prestador') {
            id = dados_user['prestador_id'];
        } else {
            this.props.router.navigate("/home");
        }

        if(!id) {
            this.props.router.navigate("/home");
        }

        this.setState({
            prestador_id: id,
            loading: true,
            erroLoadRegistro: ''
        })
        
        //consulta os dados do agendamento na api
        api.get(`/pessoas/prestadores/${id}`)
        .then(response => {
            const dados = response.data;

            //preenche os inputs
            this.setState({
                erroLoadRegistro: '',
                nome: dados.nome,
                razao_social: dados.razao_social,
                nome_fantasia: dados.nome_fantasia,
                tipo_pessoa: dados.tipo_pessoa,
                telefone: dados.telefone,
                celular: dados.celular,
                endereco: dados.endereco,
                numero: dados.numero,
                complemento: dados.complemento,
                bairro: dados.bairro,
                cep: dados.cep,
                uf: dados.uf,
                cidade: dados.cidade,
                genero: dados.genero,
                mentor: dados.mentor,
                registro: dados.registro,
                registro_uf: dados.registro_uf,
                categoria: dados.categoria,
                contato_nome: dados.contato_nome,
                contato_email: dados.contato_email,
                contato_celular: dados.contato_celular,
                logomarca_pdf_termo: dados.logomarca_pdf_termo,
                midias_contato: dados.midias_contato ? dados.midias_contato.split(',') : [],
                loading: false,
                titulo_pagina: 'minhaConta:pageTitle',
            })      
            this.carregarLaboratoriosMedico();          
            this.carregarLaboratoriosDisponiveis();
            this.carregaDadosPrograma();
        })
        .catch(error => {
            let erro_msg = t('minhaConta:alert.loadFailed');
            console.error(error);

            if(error.response && error.response.status === 500){
                erro_msg = t('minhaConta:alert.serverBusy');
            }

            this.setState({
                erroLoadRegistro: erro_msg,
            })
        });
       
    }

    //Laboratórios do Médico
    carregarLaboratoriosMedico = () => {
        const { t } = this.props;
        if (this.state.prestador_id) {
            const dados_usuario = getCurrentUser();
            api.get(`/pessoas/prestadores/laboratorios/?medico_id=${this.state.prestador_id}&tipo_usuario=${dados_usuario.tipo_usuario}`)
                .then(response => {
                    const laboratoriosCarregados = response.data.results.map(laboratorio => (laboratorio.laboratorio_id));
                    this.setState({ laboratoriosSelecionados: laboratoriosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar laboratórios:', error);
                    
                    let erro_msg = t('minhaConta:alert.labsFailed');

                    if(error.response && error.response.status === 500){
                        erro_msg = t('minhaConta:alert.serverBusy');
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    enviaRegistro = (e) => {
        const { t } = this.props;
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            telefoneHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            contatoNomeHelper: '',
            contatoCelularHelper: '',
        });

        const midiasContatoString = this.state.midias_contato.join(',');
        const laboratoriosString = this.state.laboratoriosSelecionados.join(',');

        formData.append('nome', (this.state.tipo_pessoa == 'fisica') ? this.state.nome : this.state.razao_social);
        formData.append('razao_social', this.state.razao_social);
        formData.append('nome_fantasia', this.state.nome_fantasia);
        formData.append('tipo_pessoa', this.state.tipo_pessoa);
        formData.append('telefone', this.state.telefone);
        formData.append('celular', this.state.celular);
        formData.append('endereco', this.state.endereco);
        formData.append('numero', this.state.numero);
        formData.append('complemento', this.state.complemento);
        formData.append('bairro', this.state.bairro);
        formData.append('cep', this.state.cep);
        formData.append('uf', this.state.uf);
        formData.append('cidade', this.state.cidade);     
        formData.append('categoria', this.state.categoria);   
        if(this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais') {
            formData.append('registro', this.state.registro);
            formData.append('registro_uf', this.state.registro_uf);
        } else {
            formData.append('registro', '1');
            formData.append('registro_uf', (this.state.uf) ? this.state.uf : 'SP');
        }
        formData.append('contato_nome', this.state.contato_nome);
        formData.append('contato_celular', this.state.contato_celular);

        if(this.state.tipo_pessoa == 'fisica'){
            formData.append('genero', this.state.genero);
        }

        if(midiasContatoString) {
            formData.append('midias_contato', midiasContatoString);
        } else {
            formData.append('midias_contato', "");
        }

        if(laboratoriosString){          
            formData.append('laboratorios', laboratoriosString);
        }
        else {
            formData.append('laboratorios', "");
        }

        //envia para api
        api({
            method: 'PUT',
            url: '/prestadores-conta/atualizar/',
            data: formData,
        })
        .then(response => {        
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'success',
                showCloseButton: true,
                title: t('minhaConta:alert.successTitle'),
                html: t('minhaConta:alert.updated'),
            })   

            this.setState({
                loading: false,
            })
        })
        .catch(error => {
            let erro_msg = t('minhaConta:alert.updateFailed');                

            console.error(error.response)

            if(error.response && error.response.status === 500){
                erro_msg = t('minhaConta:alert.serverBusyRetry');
            }
            else if(error.response && error.response.status === 400){
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;             
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                                     
                    if(key === 'nome'){
                        erro_msg += "<br />Nome: " + value;
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'razao_social'){
                        erro_msg += "<br />Razão Social: " + value;
                        this.setState({ razaoSocialHelper: value })
                    }
                    if(key === 'nome_fantasia'){
                        erro_msg += "<br />Nome Fantasia: " + value;
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'tipo_pessoa'){
                        erro_msg += "<br />Tipo de Pessoa: " + value;
                        this.setState({ tipoPessoaHelper: value })
                    }
                    if(key === 'telefone'){
                        erro_msg += "<br />Telefone: " + value;
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'celular'){
                        erro_msg += "<br />Celular: " + value;
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'endereco'){
                        erro_msg += "<br />Endereço: " + value;
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        erro_msg += "<br />Número: " + value;
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        erro_msg += "<br />Complemento: " + value;
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        erro_msg += "<br />Bairro: " + value;
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cep'){
                        erro_msg += "<br />CEP: " + value;
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'uf'){
                        erro_msg += "<br />UF: " + value;
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'cidade'){
                        erro_msg += "<br />Cidade: " + value;
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'genero'){
                        erro_msg += "<br />Gênero: " + value;
                        this.setState({ generoHelper: value })
                    }
                    if(key === 'registro'){
                        erro_msg += "<br />CRM: " + value;
                        this.setState({ registroHelper: value })
                    }
                    if(key === 'registro_uf'){
                        erro_msg += "<br />UF do CRM: " + value;
                        this.setState({ registroUfHelper: value })
                    }
                    if(key === 'contato_nome'){
                        erro_msg += "<br />Nome de Contato: " + value;
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_email'){
                        erro_msg += "<br />E-mail de Contato: " + value;
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'contato_celular'){
                        erro_msg += "<br />Celular de Contato: " + value;
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'username'){
                        erro_msg += "<br />" + value;
                        this.setState({ registroHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: t('minhaConta:alert.errorTitle'),
                html: erro_msg,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };


    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    handleMidiasContatoChange = (midia, isChecked) => {
        const midias_contato = [...this.state.midias_contato];
    
        if (isChecked) {
            midias_contato.push(midia);
        } else {
            const index = midias_contato.indexOf(midia);
            if (index > -1) {
                midias_contato.splice(index, 1);
            }
        }
    
        this.setState({ midias_contato });
    };

    handleLaboratorioVinculadoChange = (laboratorioId) => {
        if(laboratorioId == 'nenhum') {
            this.setState({ laboratoriosSelecionados: [] });
        } else {
            this.setState(prevState => {
                const novosSelecionados = prevState.laboratoriosSelecionados.includes(laboratorioId)
                    ? prevState.laboratoriosSelecionados.filter(id => id !== laboratorioId)
                    : [...prevState.laboratoriosSelecionados, laboratorioId];
    
    
                return { laboratoriosSelecionados: novosSelecionados };
            });
        }
    }

    carregarLaboratoriosDisponiveis = async () => {
        const dados_user = getCurrentUser();
        
        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${dados_user.ambiente_programa_id}&categoria=laboratorio_diagnostico&tipo_usuario=${dados_user.tipo_usuario}`);

            const opcoes = response.data.results
                .filter(laboratorio => !laboratorio.exclusivo_vinculados) // Filtra laboratórios onde exclusivo_vinculados é false
                .map(laboratorio => ({
                    prestador_id: laboratorio.id,
                    nome: laboratorio.nome_fantasia
                }));

            this.setState({ laboratoriosDisponiveis: opcoes });
        } catch (error) {
            console.error('Erro ao carregar laboratorios:', error);
            return [];
        }
    }

    resetarSenha = () => {
        const { t } = this.props;
        const dados_user = getCurrentUser();  // Obtém os dados do usuário
        const programa_login = Cookies.get('p_login'); // Obtém `p_login` do cookie
        const MySwal = withReactContent(Swal);
        let url = '/password_reset/';
    
        // Monta os parâmetros da URL com cliente e programa, se existirem
        if (programa_login) {
            url += 'custom/?p=' + programa_login;
        }
    
        this.setState({
            loading: true,
        });
    
        api({
            method: 'POST',
            url: url,
            data: {
                'email': dados_user.email  // Usa o email do usuário para o reset
            }
        })
        .then(response => {
            this.setState({
                loading: false,
            });
    
            MySwal.fire({
                title: t('minhaConta:alert.successTitle'),
                icon: 'success',
                html: t('minhaConta:alert.resetSent'),
                showCloseButton: true,
            });
        })
        .catch(error => {
            let msg_erro = <p>{t('minhaConta:alert.resetFailed')}</p>;
    
            if ('password' in error.response.data) {
                msg_erro = <p>{error.response.data.password}</p>;
            }
    
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                html: msg_erro,
            });
    
            this.setState({
                loading: false,
            });
        });
    };

    carregaDadosPrograma = () => {
        const dados_usuario = getCurrentUser();     
        const programa_uuid = dados_usuario['ambiente_programa_uuid'] || '';

        if(programa_uuid) {
            api.get(`/programas/${programa_uuid}/`)
            .then(response => {
                this.setState({ programa_dados: response.data });
            })
            .catch(error => {
                console.error('Erro ao carregar dados do programa atual:', error);
                
            });
        }
    };

    render(){
        const { t } = this.props;

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina && t(this.state.titulo_pagina)}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosMeusDados" id="tabs-minha-conta" className="aditus-tabs">
                    <Tab eventKey="dadosMeusDados" title={t('minhaConta:tab.myData')}>
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>{t('minhaConta:myData.title')}</h4>
                                    <Row>                                    
                                        {this.state.tipo_pessoa === 'fisica' ? (
                                        <>                                            
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('common:field.name')} <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="nome" required placeholder={t('minhaConta:myData.namePlaceholder')} value={this.state.nome} onChange={this.handleChange} />    
                                                    <Form.Text className="text-danger">{this.state.nomeHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Label>{t('common:field.gender')}</Form.Label>
                                                <div className="mb-3">
                                                {
                                                    Object.keys(this.list_generos).map((key, index) => ( 
                                                    <Form.Check inline type="radio" label={t(`enums:sexo.${key}`, { defaultValue: this.list_generos[key] })} key={key} id={key} name="genero" value={key} onChange={this.handleChange} checked={ key === this.state.genero ? true : false } />
                                                    ))
                                                }                                              
                                                </div>
                                            </Col>
                                        </>
                                        ) : (
                                        <>                                            
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('common:field.companyName')} <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="razao_social" required placeholder={t('common:field.companyName')} value={this.state.razao_social} onChange={this.handleChange} />    
                                                    <Form.Text className="text-danger">{this.state.razaoSocialHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('common:field.tradeName')} <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="nome_fantasia" required placeholder={t('common:field.tradeName')} value={this.state.nome_fantasia} onChange={this.handleChange} />    
                                                    <Form.Text className="text-danger">{this.state.nomeFantasiaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col> 
                                        </>
                                        )}                                                                            
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.phone')}</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder={t('common:field.phone')} name="telefone" value={this.state.telefone} onChange={this.handleChange} />
                                                <Form.Text className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.mobile')} <span className="text-danger">*</span></Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" required placeholder={t('common:field.mobile')} name="celular" value={this.state.celular} onChange={this.handleChange} />
                                                <Form.Text className="text-danger">{this.state.celularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>     
                                        {(this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais')  && ( 
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('common:field.crm')} <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="registro" required placeholder={t('common:field.registration')} value={this.state.registro} onChange={this.handleChange} />    
                                                    <Form.Text className="text-danger">{this.state.registroHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>{t('common:field.crmState')} <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control as="select" name="registro_uf" value={this.state.registro_uf} required onChange={this.handleChange}>
                                                        <option value="">{t('common:select.selectState')}</option>
                                                        {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text className="text-danger">{this.state.registroUfHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </>
                                        )}
                                    </Row>

                                    <h4 className="mt-3">{t('minhaConta:address.title')}</h4>
                                    <Row>                                        
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.zipCode')}</Form.Label>
                                                <Form.Control as={IMaskInput} mask="00000-000" type="text" placeholder={t('common:field.zipCode')} value={this.state.cep} onChange={this.onChangeCep} />
                                                <Form.Text className="text-danger">{this.state.cepHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.state')}</Form.Label>
                                                <Form.Control as="select" name="uf" value={this.state.uf} onChange={this.handleChange}>
                                                    <option value="">{t('common:select.selectState')}</option>
                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="text-danger">{this.state.ufHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.city')}</Form.Label>
                                                <Form.Control type="text" name="cidade" placeholder={t('common:field.city')} value={this.state.cidade} onChange={this.handleChange} />    
                                                <Form.Text className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.neighborhood')}</Form.Label>
                                                <Form.Control type="text" name="bairro" placeholder={t('common:field.neighborhood')} value={this.state.bairro} onChange={this.handleChange} />    
                                                <Form.Text className="text-danger">{this.state.bairroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.address')}</Form.Label>
                                                <Form.Control type="text" name="endereco" placeholder={t('common:field.address')} value={this.state.endereco} onChange={this.handleChange} />    
                                                <Form.Text className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.number')}</Form.Label>
                                                <Form.Control type="text" name="numero" placeholder={t('common:field.number')} value={this.state.numero} onChange={this.handleChange} />    
                                                <Form.Text className="text-danger">{this.state.numeroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>{t('common:field.complement')}</Form.Label>
                                                <Form.Control type="text" name="complemento" placeholder={t('common:field.complement')} value={this.state.complemento} onChange={this.handleChange} />    
                                                <Form.Text className="text-danger">{this.state.complementoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row> 

                                    {this.state.categoria == 'medicos'  && (
                                    <>
                                        <Row>
                                            <Col sm={12}>
                                                <h4 className="mt-3">{t('minhaConta:communications.title')}</h4>
                                                <div className="d-flex flex-wrap">
                                                {Object.keys(MidiasAceita).map((midia) => (
                                                    <div className="p-2" key={`midia-${midia}`}>
                                                        <Form.Check 
                                                            type="checkbox"
                                                            id={`midia-${midia}`}
                                                            label={MidiasAceita[midia]}
                                                            checked={this.state.midias_contato.includes(midia)}
                                                            onChange={e => this.handleMidiasContatoChange(midia, e.target.checked)}
                                                        />
                                                    </div>
                                                ))}
                                                </div>
                                            </Col>
                                        </Row>       
                                        {getConfig(this.state.programa_dados.configuracoes, 'cadastro_medico.escolha_laboratorio', false) && (                          
                                        <Row>
                                            <Col sm={12}>
                                                <h4 className="mt-3">{t('minhaConta:lab.title')}</h4>
                                                <div className="d-flex flex-wrap">
                                                    <div key='nenhum' className="p-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`nenhum`}
                                                            label={t('common:field.none')}
                                                            checked={this.state.laboratoriosSelecionados.length === 0}
                                                            onChange={() => this.handleLaboratorioVinculadoChange('nenhum')}
                                                        />
                                                    </div>
                                                    {this.state.laboratoriosDisponiveis.map(laboratorio => (
                                                        <div key={laboratorio.prestador_id} className="p-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                id={`laboratorio-${laboratorio.prestador_id}`}
                                                                label={laboratorio.nome?.replace(/\s*\(.*?\)/, '')}
                                                                checked={this.state.laboratoriosSelecionados.includes(laboratorio.prestador_id)}
                                                                onChange={() => this.handleLaboratorioVinculadoChange(laboratorio.prestador_id)}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                        )}
                                    </>
                                    )}

                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    <Tab eventKey="dadosAlterarSenha" title={t('minhaConta:tab.changePassword')}>
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <h4>{t('minhaConta:changePassword.title')}</h4>
                                <p>{t('minhaConta:changePassword.hint')}</p>
                                <Button variant="success" type="submit" className="btn-submit mt-2" onClick={this.resetarSenha} disabled={this.state.loading}>
                                    {this.state.loading ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : (
                                        <>
                                            {t('minhaConta:changePassword.submit')}
                                        </>
                                    )}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Tab>
                    <Tab eventKey="dadosPreferencias" title={t('minhaConta:tab.preferences')}>
                        <Card className="cardDestaque">
                            <Card.Body>
                                <h4>{t('minhaConta:preferences.title')}</h4>
                                <Row>
                                    <Col sm={6} xs={12}>
                                        <div className="mb-3">
                                            <SeletorIdiomaCampo />
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

MinhaContaEdit.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(['minhaConta', 'common', 'enums'])(withRouter(MinhaContaEdit));